import React from 'react'
import {Box, Typography} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import Button from 'src/components-new/primitives/Button'
import ActionIconButton from 'src/components-new/primitives/ActionIconButton'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

export interface ExportFileType {
  fileId: string
  fileName: string
  templateId: string
  templateName: string
}

interface ExportFilesDialogNewProps {
  open: boolean
  onClose: () => void
  exportFiles: ExportFileType[]
  onPick: (index: number) => void
}

/**
 * Lists the multiple form templates ("exportFiles") generable for a single
 * pharmacovigilance event. Picking one opens ConfirmGenerateFormDialogNew on
 * top of this dialog — this dialog stays mounted/open underneath so the user
 * can come back and pick a different file after cancelling the confirm step.
 */
export default function ExportFilesDialogNew({open, onClose, exportFiles, onPick}: ExportFilesDialogNewProps): JSX.Element {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Generazione Forms Farmaco Vigilanza"
      actions={<Button variant="secondary" onClick={onClose}>{'Chiudi'}</Button>}
    >
      <Typography variant="body2" sx={{mb: 2}}>
        {'Tipi di Form generabili per questo evento:'}
      </Typography>
      <Box sx={{border: `1px solid ${NEUTRAL_SCALE[200]}`, borderRadius: '8px', overflow: 'hidden'}}>
        {exportFiles.map((file, index) => (
          <Box
            key={file.fileId}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              px: 2,
              py: 1.5,
              borderBottom: index < exportFiles.length - 1 ? `1px solid ${NEUTRAL_SCALE[200]}` : 'none',
            }}
          >
            <Typography variant="body2">{file.fileName}</Typography>
            <ActionIconButton variant="download" tooltip="Genera form" onClick={() => onPick(index)} />
          </Box>
        ))}
      </Box>
    </AppDialog>
  )
}
